import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';

// Every short message of the app, one style (.uvToast in styles.scss): at the
// top under the header, as wide as its text. A confirmation goes away by
// itself; an error stays longer and has OK.
@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private readonly snackBar = inject(MatSnackBar);
  private readonly translate = inject(TranslateService);

  // message: a phrase key, or a text already in the user's language (a server error).
  public done(message: string): void {
    this.open(message, false);
  }

  public error(message: string): void {
    this.open(message, true);
  }

  private open(message: string, error: boolean): void {
    this.translate.get(message).pipe(take(1)).subscribe((text: string) => {
      this.snackBar.open(text, error ? 'OK' : undefined, {
        duration: error ? 30000 : 4000,
        verticalPosition: 'top',
        panelClass: error ? ['uvToast', 'uvToastError'] : ['uvToast']
      });
    });
  }
}
